import { PACKAGES } from './constants';
import FEATURES, { Feature } from './features';
import { featureIsNonGuacOnly } from './helpers';

export type PackageFeatures = Feature[];

type PackageFeaturesList = {
  [packageId: string]: PackageFeatures;
};

const PACKAGE_SUMMARY_FEATURES: PackageFeaturesList = {
  [PACKAGES.StandardMonthly]: [
    {
      summaryLine: 'Matrix of dropdown menus question type',
      tooltip: FEATURES.summary_matrix_of_dropdown_menus.tooltip,
    },
    {
      summaryLine: 'Unlimited number of surveys',
      tooltip: FEATURES.summary_number_of_surveys.tooltip,
    },
    {
      summaryLine: 'Unlimited questions per survey',
      tooltip: FEATURES.summary_questions_per_survey.tooltip,
    },
    {
      summaryLine: 'Unlimited responses per survey',
      tooltip: FEATURES.summary_number_of_responses.tooltip,
    },
    {
      summaryLine: '24/7 priority email support',
      tooltip: FEATURES.summary_customer_support.tooltip,
    },
    {
      summaryLine: '24/7 English email support',
      tooltip: FEATURES.summary_english_customer_support.tooltip,
    },
    {
      summaryLine: '{lang} email support',
      tooltip: FEATURES.summary_international_customer_support.tooltip,
    },
    {
      summaryLine: 'Quizzes with custom feedback',
      tooltip: FEATURES.summary_quizzes.tooltip,
    },
    {
      summaryLine: 'Custom logo, colors, and survey URL',
      tooltip: FEATURES.summary_customized_surveys.tooltip,
    },
    {
      summaryLine: 'Data exports (CSV, PDF, PPT, XLS)',
      tooltip: FEATURES.summary_data_exports.tooltip,
    },
    {
      summaryLine: 'Skip logic only',
      tooltip: FEATURES.summary_customized_survey_experience.tooltip,
    },
    {
      summaryLine: 'Text analysis',
      tooltip: FEATURES.summary_advanced_survey_analysis.tooltip,
    },
  ],
  [PACKAGES.StandardAnnual]: [
    {
      summaryLine: 'Matrix of dropdown menus question type',
      tooltip: FEATURES.summary_matrix_of_dropdown_menus.tooltip,
    },
    {
      summaryLine: 'Unlimited number of surveys',
      tooltip: FEATURES.summary_number_of_surveys.tooltip,
    },
    {
      summaryLine: 'Unlimited questions per survey',
      tooltip: FEATURES.summary_questions_per_survey.tooltip,
    },
    {
      summaryLine: 'Unlimited responses per survey',
      tooltip: FEATURES.summary_number_of_responses.tooltip,
    },
    {
      summaryLine: '24/7 priority email support',
      tooltip: FEATURES.summary_customer_support.tooltip,
    },
    {
      summaryLine: '24/7 English email support',
      tooltip: FEATURES.summary_english_customer_support.tooltip,
    },
    {
      summaryLine: '{lang} email support',
      tooltip: FEATURES.summary_international_customer_support.tooltip,
    },
    {
      summaryLine: 'Quizzes with custom feedback',
      tooltip: FEATURES.summary_quizzes.tooltip,
    },
    {
      summaryLine: 'Custom logo, colors, and survey URL',
      tooltip: FEATURES.summary_customized_surveys.tooltip,
    },
    {
      summaryLine: 'Data exports (CSV, PDF, PPT, XLS)',
      tooltip: FEATURES.summary_data_exports.tooltip,
    },
    {
      summaryLine: 'Skip logic only',
      tooltip: FEATURES.summary_customized_survey_experience.tooltip,
    },
    {
      summaryLine: 'Text analysis',
      tooltip: FEATURES.summary_advanced_survey_analysis.tooltip,
    },
  ],
  [PACKAGES.AdvantageAnnual]: [
    {
      summaryLine: 'Accept Payments',
      tooltip: FEATURES.summary_accept_payments.tooltip,
    },
    {
      summaryLine: 'Carry forward responses',
      tooltip: FEATURES.summary_carry_forward.tooltip,
    },
    {
      summaryLine: 'Matrix of dropdown menus question type',
      tooltip: FEATURES.summary_matrix_of_dropdown_menus.tooltip,
    },
    {
      summaryLine: 'Unlimited number of surveys',
      tooltip: FEATURES.summary_number_of_surveys.tooltip,
    },
    {
      summaryLine: 'Unlimited questions per survey',
      tooltip: FEATURES.summary_questions_per_survey.tooltip,
    },
    {
      summaryLine: 'Unlimited responses per survey',
      tooltip: FEATURES.summary_number_of_responses.tooltip,
    },
    {
      summaryLine: '24/7 expedited email support',
      tooltip: FEATURES.summary_customer_support.tooltip,
    },
    {
      summaryLine: '24/7 expedited English email support',
      tooltip: FEATURES.summary_english_customer_support.tooltip,
    },
    {
      summaryLine: '{lang} email support',
      tooltip: FEATURES.summary_international_customer_support.tooltip,
    },
    {
      summaryLine: 'Quizzes with custom feedback',
      tooltip: FEATURES.summary_quizzes.tooltip,
    },
    {
      summaryLine: 'Custom logo, colors, and survey URL',
      tooltip: FEATURES.summary_customized_surveys.tooltip,
    },
    {
      summaryLine: 'Data exports (CSV, PDF, PPT, XLS)',
      tooltip: FEATURES.summary_data_exports.tooltip,
    },
    {
      summaryLine: 'Advanced data exports (SPSS)',
      tooltip: FEATURES.summary_advanced_data_exports.tooltip,
    },
    {
      summaryLine: 'Skip logic, question & answer piping',
      tooltip: FEATURES.summary_customized_survey_experience.tooltip,
    },
    {
      summaryLine: 'Text analysis & statistical significance',
      tooltip: FEATURES.summary_advanced_survey_analysis.tooltip,
    },
    {
      summaryLine:
        '<span class="notranslate">{audience_wallet_credit}</span> Audience panel credits<span class="asterisk">**</span>',
      tooltip: FEATURES.summary_complimentary_audience_credits.tooltip,
    },
    {
      summaryLine: 'Custom variables',
      tooltip: FEATURES.summary_custom_variables.tooltip,
    },
    {
      summaryLine: 'File upload',
      tooltip: FEATURES.summary_file_upload.tooltip,
    },
    {
      summaryLine: 'A/B testing, randomization, quotas',
      tooltip: FEATURES.summary_a_b_testing.tooltip,
    },
    {
      summaryLine: 'SurveyMonkey industry benchmarks',
      tooltip: FEATURES.summary_industry_benchmarks.tooltip,
    },
    {
      summaryLine: 'Multilingual surveys',
      tooltip: FEATURES.summary_multilingual.tooltip,
    },
  ],
  [PACKAGES.PremierAnnual]: [
    {
      summaryLine: 'Accept Payments',
      tooltip: FEATURES.summary_accept_payments.tooltip,
    },
    {
      summaryLine: 'Carry forward responses',
      tooltip: FEATURES.summary_carry_forward.tooltip,
    },
    {
      summaryLine: 'Matrix of dropdown menus question type',
      tooltip: FEATURES.summary_matrix_of_dropdown_menus.tooltip,
    },
    {
      summaryLine: 'Unlimited number of surveys',
      tooltip: FEATURES.summary_number_of_surveys.tooltip,
    },
    {
      summaryLine: 'Unlimited questions per survey',
      tooltip: FEATURES.summary_questions_per_survey.tooltip,
    },
    {
      summaryLine: 'Unlimited responses per survey',
      tooltip: FEATURES.summary_number_of_responses.tooltip,
    },
    {
      summaryLine: 'Phone support and 24/7 email support',
      tooltip: FEATURES.summary_customer_support.tooltip,
    },
    {
      summaryLine: 'Phone support and 24/7 English email support',
      tooltip: FEATURES.summary_english_customer_support.tooltip,
    },
    {
      summaryLine: '{lang} email support',
      tooltip: FEATURES.summary_international_customer_support.tooltip,
    },
    {
      summaryLine: 'Quizzes with custom feedback',
      tooltip: FEATURES.summary_quizzes.tooltip,
    },
    {
      summaryLine: 'Custom logo, colors, and survey URL',
      tooltip: FEATURES.summary_customized_surveys.tooltip,
    },
    {
      summaryLine: 'Data exports (CSV, PDF, PPT, XLS)',
      tooltip: FEATURES.summary_data_exports.tooltip,
    },
    {
      summaryLine: 'Advanced data exports (SPSS)',
      tooltip: FEATURES.summary_advanced_data_exports.tooltip,
    },
    {
      summaryLine: 'Skip logic, question & answer piping',
      tooltip: FEATURES.summary_customized_survey_experience.tooltip,
    },
    {
      summaryLine: 'Text analysis & statistical significance',
      tooltip: FEATURES.summary_advanced_survey_analysis.tooltip,
    },
    {
      summaryLine: 'Sentiment analysis',
      tooltip: FEATURES.summary_sentiment_analysis.tooltip,
    },
    {
      summaryLine: 'Crosstabs',
      tooltip: FEATURES.crosstab.tooltip,
    },
    {
      summaryLine: 'Unlimited filter and compare rules, data trends',
      tooltip: FEATURES.summary_filters_and_crosstabs.tooltip,
    },
    {
      summaryLine:
        '<span class="notranslate">{audience_wallet_credit}</span> Audience panel credits<span class="asterisk">**</span>',
      tooltip: FEATURES.summary_complimentary_audience_credits.tooltip,
    },
    {
      summaryLine: 'File upload',
      tooltip: FEATURES.summary_file_upload.tooltip,
    },
    {
      summaryLine: 'Advanced branching & piping, block randomization',
      tooltip: FEATURES.summary_advanced_logic.tooltip,
    },
    {
      summaryLine: 'A/B testing, randomization, quotas',
      tooltip: FEATURES.summary_a_b_testing.tooltip,
    },
    {
      summaryLine: 'Custom variables',
      tooltip: FEATURES.summary_custom_variables.tooltip,
    },
    {
      summaryLine: 'White label surveys',
      tooltip: FEATURES.summary_collector_white_label_enabled.tooltip,
    },
    {
      summaryLine: 'SurveyMonkey industry benchmarks',
      tooltip: FEATURES.summary_industry_benchmarks.tooltip,
    },
    {
      summaryLine: 'Multilingual surveys',
      tooltip: FEATURES.summary_multilingual.tooltip,
    },
  ],
  [PACKAGES.TeamAdvantage]: [
    {
      summaryLine: 'Survey sharing with fine control over who can view and edit',
      tooltip: FEATURES.summary_team_share_surveys.tooltip,
    },
    {
      summaryLine: 'Gather comments all in one place',
      tooltip: FEATURES.summary_team_comments.tooltip,
    },
    {
      summaryLine: 'Let team members analyze, filter, and export results',
      tooltip: FEATURES.summary_team_analyze_filter_export.tooltip,
    },
    {
      summaryLine: 'Notify others when you get new responses',
      tooltip: FEATURES.summary_team_responses_nodification.tooltip,
    },
    {
      summaryLine: 'Shared asset library for on-brand surveys',
      tooltip: FEATURES.summary_team_shared_library.tooltip,
    },
    {
      summaryLine: 'Add or reassign accounts at any time',
      tooltip: FEATURES.summary_team_add_reassign_accounts.tooltip,
    },
    {
      summaryLine: 'Free integrations with popular collaboration apps',
      tooltip: FEATURES.summary_team_collaboration_app_integrations.tooltip,
    },
    {
      summaryLine: 'Unlimited surveys, questions, and responses',
      tooltip: FEATURES.summary_team_surveys_questions_responses.tooltip,
    },
    {
      summaryLine: '24/7 Expedited email support',
      tooltip: FEATURES.summary_team_expedited_email_support.tooltip,
    },
    {
      summaryLine: 'Quizzes with custom feedback',
      tooltip: FEATURES.summary_team_quizzes.tooltip,
    },
    {
      summaryLine: 'Custom logo, colors, and survey URL',
      tooltip: FEATURES.summary_team_custom_logo.tooltip,
    },
    {
      summaryLine: 'Question and page skip logic',
      tooltip: FEATURES.summary_team_skip_logic.tooltip,
    },
    {
      summaryLine: 'All data exports (CSV, PDF, PPT, SPSS, XLS)',
      tooltip: FEATURES.summary_team_data_exports.tooltip,
    },
    {
      summaryLine: 'Accept Payments',
      tooltip: FEATURES.summary_accept_payments.tooltip,
    },
    {
      summaryLine: 'Advanced analyze features',
      tooltip: FEATURES.summary_team_advanced_analyze.tooltip,
    },
    {
      summaryLine: 'SurveyMonkey industry benchmarks',
      tooltip: FEATURES.summary_team_industry_benchmarks.tooltip,
    },
    {
      summaryLine: 'Multilingual surveys',
      tooltip: FEATURES.summary_team_multilingual.tooltip,
      // Hide for GUAC countries
      get hidden(): boolean {
        return featureIsNonGuacOnly();
      },
    },
  ],
  [PACKAGES.TeamPremier]: [
    {
      summaryLine: 'Survey sharing with fine control over who can view and edit',
      tooltip: FEATURES.summary_team_share_surveys.tooltip,
    },
    {
      summaryLine: 'Gather comments all in one place',
      tooltip: FEATURES.summary_team_comments.tooltip,
    },
    {
      summaryLine: 'Let team members analyze, filter, and export results',
      tooltip: FEATURES.summary_team_analyze_filter_export.tooltip,
    },
    {
      summaryLine: 'Notify others when you get new responses',
      tooltip: FEATURES.summary_team_responses_nodification.tooltip,
    },
    {
      summaryLine: 'Shared asset library for on-brand surveys',
      tooltip: FEATURES.summary_team_shared_library.tooltip,
    },
    {
      summaryLine: 'Add or reassign accounts at any time',
      tooltip: FEATURES.summary_team_add_reassign_accounts.tooltip,
    },
    {
      summaryLine: 'Free integrations with popular collaboration apps',
      tooltip: FEATURES.summary_team_collaboration_app_integrations.tooltip,
    },
    {
      summaryLine: 'Unlimited surveys, questions, and responses',
      tooltip: FEATURES.summary_team_surveys_questions_responses.tooltip,
    },
    {
      summaryLine: 'Phone support and 24/7 email support',
      tooltip: FEATURES.summary_team_expedited_email_support.tooltip,
    },
    {
      summaryLine: 'Quizzes with custom feedback',
      tooltip: FEATURES.summary_team_quizzes.tooltip,
    },
    {
      summaryLine: 'Custom logo, colors, and survey URL',
      tooltip: FEATURES.summary_team_custom_logo.tooltip,
    },
    {
      summaryLine: 'Question and page skip logic',
      tooltip: FEATURES.summary_team_skip_logic.tooltip,
    },
    {
      summaryLine: 'All data exports (CSV, PDF, PPT, SPSS, XLS)',
      tooltip: FEATURES.summary_team_data_exports.tooltip,
    },
    {
      summaryLine: 'Accept Payments',
      tooltip: FEATURES.summary_accept_payments.tooltip,
    },
    {
      summaryLine: 'Advanced analyze features',
      tooltip: FEATURES.summary_team_advanced_analyze.tooltip,
    },
    {
      summaryLine: 'Sentiment analysis',
      tooltip: FEATURES.summary_sentiment_analysis.tooltip,
    },
    {
      summaryLine: 'Crosstabs',
      tooltip: FEATURES.crosstab.tooltip,
    },
    {
      summaryLine: 'Unlimited filter and compare rules, data trends',
      tooltip: FEATURES.summary_team_filters_and_crosstabs.tooltip,
    },
    {
      summaryLine: 'SurveyMonkey industry benchmarks',
      tooltip: FEATURES.summary_team_industry_benchmarks.tooltip,
    },
    {
      summaryLine: 'Advanced survey logic tools',
      tooltip: FEATURES.summary_team_advanced_survey_logic.tooltip,
    },
    {
      summaryLine: 'Block randomization',
      tooltip: FEATURES.summary_team_block_randomization.tooltip,
    },
    {
      summaryLine: 'White label surveys',
      tooltip: FEATURES.summary_team_white_label.tooltip,
    },
    {
      summaryLine: 'Multilingual surveys',
      tooltip: FEATURES.summary_team_multilingual.tooltip,
    },
    {
      summaryLine: 'Survey completion redirect',
      tooltip: FEATURES.summary_team_completion_redirect.tooltip,
    },
    {
      summaryLine: 'Remove SurveyMonkey footer',
      tooltip: FEATURES.summary_team_remove_surveymonkey_footer.tooltip,
    },
    {
      summaryLine: 'Create private apps with direct API access',
      tooltip: FEATURES.summary_team_api_access.tooltip,
    },
  ],
  [PACKAGES.Enterprise]: [
    {
      summaryLine: 'Survey sharing with fine control over who can view and edit',
      tooltip: FEATURES.summary_team_share_surveys.tooltip,
    },
    {
      summaryLine: 'Gather comments all in one place',
      tooltip: FEATURES.summary_team_comments.tooltip,
    },
    {
      summaryLine: 'Let team members analyze, filter, and export results',
      tooltip: FEATURES.summary_team_analyze_filter_export.tooltip,
    },
    {
      summaryLine: 'Notify others when you get new responses',
      tooltip: FEATURES.summary_team_responses_nodification.tooltip,
    },
    {
      summaryLine: 'Shared asset library for on-brand surveys',
      tooltip: FEATURES.summary_team_shared_library.tooltip,
    },
    {
      summaryLine: 'Add or reassign accounts at any time',
      tooltip: FEATURES.summary_team_add_reassign_accounts.tooltip,
    },
    {
      summaryLine: 'Free integrations with popular collaboration apps',
      tooltip: FEATURES.summary_team_collaboration_app_integrations.tooltip,
    },
    {
      summaryLine: 'Unlimited surveys, questions, and responses',
      tooltip: FEATURES.summary_team_surveys_questions_responses.tooltip,
    },
    {
      summaryLine: 'Phone support and 24/7 email support',
      tooltip: FEATURES.summary_team_expedited_email_support.tooltip,
    },
    {
      summaryLine: 'Quizzes with custom feedback',
      tooltip: FEATURES.summary_team_quizzes.tooltip,
    },
    {
      summaryLine: 'Custom logo, colors, and survey URL',
      tooltip: FEATURES.summary_team_custom_logo.tooltip,
    },
    {
      summaryLine: 'Question and page skip logic',
      tooltip: FEATURES.summary_team_skip_logic.tooltip,
    },
    {
      summaryLine: 'All data exports (CSV, PDF, PPT, SPSS, XLS)',
      tooltip: FEATURES.summary_team_data_exports.tooltip,
    },
    {
      summaryLine: 'Accept Payments',
      tooltip: FEATURES.summary_accept_payments.tooltip,
    },
    {
      summaryLine: 'Advanced analyze features',
      tooltip: FEATURES.summary_team_advanced_analyze.tooltip,
    },
    {
      summaryLine: 'Sentiment analysis',
      tooltip: FEATURES.summary_sentiment_analysis.tooltip,
    },
    {
      summaryLine: 'Crosstabs',
      tooltip: FEATURES.crosstab.tooltip,
    },
    {
      summaryLine: 'Unlimited filter and compare rules, data trends',
      tooltip: FEATURES.summary_team_filters_and_crosstabs.tooltip,
    },
    {
      summaryLine: 'SurveyMonkey industry benchmarks',
      tooltip: FEATURES.summary_team_industry_benchmarks.tooltip,
    },
    {
      summaryLine: 'Advanced survey logic tools',
      tooltip: FEATURES.summary_team_advanced_survey_logic.tooltip,
    },
    {
      summaryLine: 'Block randomization',
      tooltip: FEATURES.summary_team_block_randomization.tooltip,
    },
    {
      summaryLine: 'White label surveys',
      tooltip: FEATURES.summary_team_white_label.tooltip,
    },
    {
      summaryLine: 'Multilingual surveys',
      tooltip: FEATURES.summary_team_multilingual.tooltip,
    },
    {
      summaryLine: 'Survey completion redirect',
      tooltip: FEATURES.summary_team_completion_redirect.tooltip,
    },
    {
      summaryLine: 'Remove SurveyMonkey footer',
      tooltip: FEATURES.summary_team_remove_surveymonkey_footer.tooltip,
    },
    {
      summaryLine: 'Unlimited API access**',
      tooltip: FEATURES.summary_team_unlimited_api_access.tooltip,
    },
    {
      summaryLine: 'Flexible plan types for multiple users',
      tooltip: FEATURES.summary_team_flexible_plan_types.tooltip,
    },
    {
      summaryLine: 'HIPAA-compliant features**',
      tooltip: FEATURES.summary_team_hipaa_compliant.tooltip,
    },
    {
      summaryLine: 'Customization and branding',
      tooltip: FEATURES.summary_team_custom_branding.tooltip,
    },
    {
      summaryLine: 'Integrations with Salesforce, Marketo, Eloqua, and Tableau**',
      tooltip: FEATURES.summary_team_3rd_part_integrations.tooltip,
    },
    {
      summaryLine: 'Admin dashboard and user management',
      tooltip: FEATURES.summary_team_admin_dashboard.tooltip,
    },
    {
      summaryLine: 'Account control and migration',
      tooltip: FEATURES.summary_team_account_control_migration.tooltip,
    },
    {
      summaryLine: 'Enhanced governance and security features',
      tooltip: FEATURES.summary_team_enhanced_governance_security.tooltip,
    },
    {
      summaryLine: 'Single sign-on (SSO)',
      tooltip: FEATURES.summary_team_sso.tooltip,
    },
    {
      summaryLine: 'Activity tracking through audit logs',
      tooltip: FEATURES.summary_team_logs_audit.tooltip,
    },
    {
      summaryLine: 'Dedicated customer success manager',
      tooltip: FEATURES.summary_team_customer_success_manager.tooltip,
    },
  ],
};

export default PACKAGE_SUMMARY_FEATURES;
